// extracted by mini-css-extract-plugin
export default {"foodScoreTable":"psw6NJEgx7dcA1vY9nmp","pagination":"xpJyz0gXw0v5UPlbLHfZ"};